import type { AppSelectOption } from '@/components/AppSelectField.vue'

/** 素材库搜索：按内容 / 画师。 */
export const MATERIAL_SEARCH_TYPE_OPTIONS: AppSelectOption[] = [
  { label: '内容', value: '1' },
  { label: '画师', value: '2' },
]

/** 商城商品上架状态。 */
export const GOODS_STATUS_OPTIONS: AppSelectOption[] = [
  { label: '已上架', value: 1 },
  { label: '暂不上架', value: 2 },
]
